import PropTypes from 'prop-types';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import LessonInfo from './LessonInfo/LessonInfo';
import ReviewsCourse from './ReviewsCourse/ReviewsCourse';

import classes from './BottomSection.module.css';

const BottomSection = ({
  courseData,
  lessons,
  accessCourse,
  reviews
}) => {
  return (
    <div className={classes.bottomContainer}>
      <div className={classes.section}>
        <p className={classes.sectionTitle}>
          En este curso aprenderás…
        </p>
        <p>{courseData.desc}</p>
      </div>
      <div className={classes.section}>
        <p className={classes.sectionTitle}>
          ¿Qué incluye este curso?
        </p>
        <aside className={classes.courseIncludes}>
          <p className={classes.includesItem}>
            <MovieOutlinedIcon className={classes.includesIcon} />
            Lecciones {lessons.lessonExtraInfo.lessons.total} (
            {lessons.lessonExtraInfo.lessons.seconds / 60 / 60} hrs)
          </p>
          <p className={classes.includesItem}>
            <DescriptionOutlinedIcon
              className={classes.includesIcon}
            />
            Actividades{' '}
            {lessons.lessonExtraInfo.lessonActivities.activities}
          </p>
          <p className={classes.includesItem}>
            <AttachmentOutlinedIcon
              className={classes.includesIcon}
            />
            {
              lessons.lessonExtraInfo.lessonAdditionalMaterialList
                .length
            }{' '}
            Archivos de Material Adicional
          </p>
          <p className={classes.includesItem}>
            <figure className={classes.iconIncludesContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/consulta_diploma.png"
              />
            </figure>
            Diploma de finalización de curso
          </p>
        </aside>
      </div>
      <div className={classes.section}>
        <p className={classes.sectionTitle}>Contenidos</p>
        <aside className={classes.productContentItemsContainer}>
          {lessons.separators.map(separator => (
            <Accordion
              className={classes.productContentPanel}
              key={separator.separator.idSeparator}
            >
              <AccordionSummary
                className={classes.productContentTitle}
                expandIcon={
                  <ExpandMoreIcon
                    className={classes.productContentPanelIcon}
                  />
                }
              >
                <Typography
                  className={classes.productContentPanelTitle}
                >
                  {separator.separator.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                className={classes.lessonAcordionDetails}
              >
                {separator.lessons.map(lesson => (
                  <LessonInfo
                    key={lesson.idVideo}
                    data={lesson}
                    accessCourse={accessCourse}
                  />
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
          {lessons.lessons.map(lesson => (
            <LessonInfo
              key={lesson.idVideo}
              data={lesson}
              accessCourse={accessCourse}
            />
          ))}
        </aside>
      </div>
      <div className={classes.section}>
        <p className={classes.sectionTitle}>Material Adicional</p>
        <aside className={classes.productContentItemsContainer}>
          {lessons.lessonExtraInfo.lessonAdditionalMaterialList.map(
            material => (
              <aside
                key={material.idMaterial}
                className={classes.materialItem}
              >
                <figure
                  className={classes.productIconAditionalMaterial}
                >
                  <img
                    className={classes.img}
                    src="https://d1g6c01s9ssd7h.cloudfront.net/img/Documento_icon.png"
                  />
                </figure>
                <p>{material.materialName}</p>
              </aside>
            )
          )}
        </aside>
      </div>
      {courseData.reviews > 0 && (
        <div className={classes.section}>
          <ReviewsCourse courseReviews={reviews} />
        </div>
      )}
    </div>
  );
};

BottomSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  courseData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  reviews: PropTypes.object
};

export default BottomSection;
